export const MIN_LISTING_PRICE = 0.05
export const MAX_LISTING_PRICE = 9999.99
